
import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import WhatsappBusinessApiContent from './WhatsappBusinessApiContent';

const WhatsappBusinessApi = () => {
    return (
        <>
        <Helmet>
            <title>WhatsApp Business API Platform | HAWKTRION</title>
            <meta name="description" content="Manage WhatsApp Business messaging, templates, campaigns, CRM, notifications, and API integrations in one HAWKTRION platform." />
            <meta name="keywords" content="WhatsApp Business API platform, WhatsApp business messaging, WhatsApp API for businesses" />
            <meta name="robots" content="index,follow" />
            <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-business-api/" />
            <meta property="og:title" content="WhatsApp Business API Platform | HAWKTRION" />
            <meta property="og:description" content="Manage WhatsApp Business messaging, templates, campaigns, CRM, notifications, and API integrations in one HAWKTRION platform." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-business-api/" />
            <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="WhatsApp Business API Platform | HAWKTRION" />
            <meta name="twitter:description" content="Manage WhatsApp Business messaging, templates, campaigns, CRM, notifications, and API integrations in one HAWKTRION platform." />
            <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
        </Helmet>
        <SeoLandingPage title="WhatsApp Business API Platform" hideCta>
            <WhatsappBusinessApiContent />
        </SeoLandingPage>
        </>
    );
};

export default WhatsappBusinessApi;